import {Component, OnInit} from '@angular/core';
import {TitleWrapperService} from "../../../service/title-wrapper.service";
import {TranslationService} from "../../../service/translation.service";

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  constructor(
    private translationService: TranslationService,
    private titleService: TitleWrapperService,
  ) {
  }

  ngOnInit(): void {
    this.updateTitle();
  }

  private updateTitle() {
    this.titleService.setPageName(this.translationService.trans("reset_password.page_title", "Reset password"));
  }

}
